// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"24":"component---src-pages-impressum-tsx","245":"component---src-pages-index-tsx"}[chunkId] + "-" + {"24":"98423198d91db3d26ee1","245":"007f10770d83d896de02"}[chunkId] + ".js";
};